// import { w3mProvider } from '@web3modal/ethereum'
import { useAccount, useConnect, useDisconnect, configureChains, createConfig, WagmiConfig } from 'wagmi'
import { arbitrum, mainnet, polygon, bsc, avalanche } from 'wagmi/chains'
import { publicProvider } from 'wagmi/providers/public'
import React, { useContext, useEffect } from 'react'
import { OrderDetailsApiDtoProvider } from 'nexchange-service'
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
// import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { LibButton, LibButtonProps } from '../elements/LibButton'
import styled from '@emotion/styled'


const chains = [arbitrum, mainnet, polygon, avalanche, bsc]
const networks = ["ARB", "ETH", "MATIC", "AVAX", "BSC"]
const projectId = process.env.WALLETCONNECT_PROJECT_ID
const ErrorLabel = styled.div`
    color: red;
    margin: 1rem 0;
    font-weight: bold;
`

const ConnectorsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 1rem;
    margin-top: 1rem;
`

const StyledButton = styled(LibButton) <LibButtonProps>`
    display: flex;
    align-items: center;
    text-align: center;
    gap: 0.25rem;
    width: 15rem;

    background-color: white;
    color: #1da1f2;
    border: 2px solid #1da1f2;
`
// Fallback to public provider since @web3modal/ethereum is excluded from build
const { publicClient } = configureChains(chains, [
  // w3mProvider({ projectId }), // Excluded from build due to wagmi version conflicts
  publicProvider()
])

const connectors = [
  new MetaMaskConnector({ chains }),
  new CoinbaseWalletConnector({
    chains,
    options: {
      appName: 'wagmi',
    },
  }),
  // new WalletConnectConnector({
  //   chains: [mainnet, polygon],
  //   options: {
  //     projectId: projectId,
  //   },
  // }),
]

const icons = [
  '/images/logo/icons/metamask-icon.png',
  '/images/logo/icons/coinbase-wallet-logo.png',
]

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: connectors,
  publicClient
})

function Profile(props: { setWithdrawalAddress: any }) {
  const { address, isConnected } = useAccount()
  const { pair } = useContext(OrderDetailsApiDtoProvider)
  if (!networks.includes(pair.base.network?.name)) {
    return <></>
  }
  const { connect, connectors, error, isLoading, pendingConnector } = useConnect()
  useEffect(() => {
    if (isConnected) {
      try {
        props.setWithdrawalAddress({
          address: address,
          extraId: null
        })
      } catch (error) {
        console.log(error);
      }
    }
  }, [address])
  const { disconnect } = useDisconnect()
  const disconnectWallet = () => {
    disconnect()
    props.setWithdrawalAddress({
      address: '',
      extraId: null
    })
  }

  if (isConnected) {
    return (
      <div>
        <StyledButton onClick={disconnectWallet}>Disconnect</StyledButton>
      </div>
    )
  }
  return (
    <ConnectorsContainer>
      <h4 className="color-primary">Connect wallet here</h4>
      {connectors.map((connector, index) => (
        connector.ready && <StyledButton
          disabled={!connector.ready}
          key={connector.id}
          onClick={() => connect({ connector })}
        >
          <img style={{ width: "2rem" }} src={icons[index]}></img>
          {connector.name}
          {isLoading &&
            connector.id === pendingConnector?.id &&
            ' (connecting)'}
        </StyledButton>
      ))}

      {error && (error.message ? <ErrorLabel>{error.message}</ErrorLabel> : <ErrorLabel>Error Occured.</ErrorLabel>)}
    </ConnectorsContainer>
  )
}
const WalletConnectModal = (props: { setWithdrawalAddress: any }) => {
  return (
    <>
      <WagmiConfig config={wagmiConfig}>
        <Profile setWithdrawalAddress={props.setWithdrawalAddress} />
      </WagmiConfig>
    </>
  )
}

export { WalletConnectModal }
